import { z } from "zod";

/**
 * Shared DTO cho admin RBAC — role của thành viên admin (US-AE1.F2-0002 / @UC9002).
 * Một nguồn sự thật cho api (S01b — guard + validate biên patch role) và
 * admin web (S04 — render/đổi role), tránh drift role-list ở 2 nơi (DRY).
 *
 * 4 role MVP đã chốt (index §6.1 DoR): SUPER_ADMIN | OPS | SUPPORT | READ_ONLY.
 * KHÔNG thêm FINANCE_OPS (out-of-scope MVP). Nhất quán với `Admin2faResponse.role`.
 *
 * BẢO MẬT (invariants):
 * - DTO chỉ mang id + role — KHÔNG lộ secret/field nhạy cảm.
 */

/** Literal union 4 role MVP — Zod enum để vừa validate biên vừa sinh type. */
export const adminRoleSchema = z.enum(["SUPER_ADMIN", "OPS", "SUPPORT", "READ_ONLY"]);

export type AdminRole = z.infer<typeof adminRoleSchema>;

/** Body của PATCH đổi role một thành viên admin. */
export const patchMemberRoleRequestSchema = z.object({
  role: adminRoleSchema,
});

export type PatchMemberRoleRequest = z.infer<typeof patchMemberRoleRequestSchema>;

/** Response GET role hiện tại của một thành viên admin (chỉ id + role). */
export interface MemberRoleResponse {
  adminMemberId: string;
  role: AdminRole;
}
